import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Catalog from './catalog/Catalog';
import { Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import history from '../history';
import '../css/app.css';
import '../css/flags.scss';

export default function App() {
	return <Router history={history}>
		<QueryParamProvider ReactRouterRoute={Route}>
			<Route exact path='/:customer/:catalog/:page' component={Catalog} />
			<Route exact path='/:customer/:catalog' component={Catalog} />
		</QueryParamProvider>
	</Router>;
}
